if(!customElements.get('infinite-features')) {
  customElements.define('infinite-features', class InfiniteFeatures extends HTMLElement {
        connectedCallback() {
          this.infiniteFeatures = this.querySelector(".infinite-features"); 
          if (this.infiniteFeatures.dataset.speed === "0"){
              this.infiniteFeatures.style.transform = "translateX(-20%)" 
              this.infiniteFeatures.style.transition = "0ms"
          }         
          this.init();
        }

      
        ux_multiply(elements, numCopies) {
          var newElements = document.createDocumentFragment();
      
          for (let i = 0; i < numCopies; i++) {
              elements.forEach((element, index) => {
                  const clonedElement = element.cloneNode(true);
                  newElements.appendChild(clonedElement);
              });
          }
    
      
          return newElements;
        }

    init() {
      let listWidth = 0;
      const item = this.infiniteFeatures.querySelectorAll(".item");
      if (item.length > 0) {
          item.forEach(item => {
              listWidth += item.getBoundingClientRect().width;
          });
          const mult = this.infiniteFeatures.getBoundingClientRect().width / listWidth;
          const itemDup = document.createElement("div");
          itemDup.classList.add("item-dup");
          this.infiniteFeatures.appendChild(itemDup);
          if (mult > 0.5) {
            itemDup.appendChild(this.ux_multiply(item, Math.ceil(mult)));
          } else {
            itemDup.appendChild(this.ux_multiply(item, 1));
          } 

          this.infiniteFeatures.style.width = listWidth + "px";
          const itemcount = this.infiniteFeatures.querySelectorAll(".item").length;
          const itemsize = listWidth / itemcount;
          let speed = this.infiniteFeatures.dataset.speed;
          let duration = itemsize * 10;

    
          if (speed === "200") {
            duration = 10;
          } else if (speed == "0") {
            duration = 0;
          } else if (speed > "100") {
            speed = parseInt(speed) - 100;
            speed = (speed / 10) * itemsize;
            duration = duration - speed;
          } else if (speed < "100") {
            speed = 100 - parseInt(speed);
            speed = (speed / 10) * (itemsize * 8);
            duration = duration + speed;
          }
          //let speed = (itemcount * duration) / 1000;
            speed = (itemcount * duration) / 1000;
            this.infiniteFeatures.style.setProperty("animation-duration", speed + "s");
        }
    }
  })
}


/* if(!customElements.get('infinite-features')) {
    customElements.define('infinite-features', class InfiniteFeatures extends HTMLElement {
          connectedCallback() {
            this.infiniteFeatures = this.querySelectorAll(".infinite-features");
            this.init();
            window.addEventListener('resize', ()=> this.init());
          }
      
        ux_multiply(elements, numCopies) {
          var newElements = document.createDocumentFragment();
          elements.forEach(element => {
              for (var i = 0; i < numCopies; i++) {
                  var clonedElement = element.cloneNode(true);
                  newElements.appendChild(clonedElement);
              }
          });

          return newElements;
      }

      init() {
        this.infiniteFeatures.forEach(infiniteFeature => {
            let listWidth = 0;
            const item = infiniteFeature.querySelectorAll(".item");
            if (item.length > 0) {
              item.forEach(item => {
                  listWidth += item.offsetWidth;
              });
              const newitems = [...item,...item,...item,...item]
              const mult = infiniteFeature.offsetWidth / listWidth;
              const itemDup = document.createElement("div");
              itemDup.classList.add("item-dup");
              infiniteFeature.appendChild(itemDup);

               if (mult > 0.5) {
                itemDup.appendChild(this.ux_multiply(item, Math.ceil(mult)));
              } else {
                itemDup.appendChild(this.ux_multiply(item, 1));
              }
              infiniteFeature.style.width = listWidth + "px";
              const itemcount = infiniteFeature.querySelectorAll(".item").length;
              const itemsize = listWidth / itemcount;
              let speed = infiniteFeature.dataset.speed;
              let duration = itemsize * 10;
      
              if (speed === "200") {
                duration = 10;
              } else if (speed == "0") {
                duration = 0;
              } else if (speed > "100") {
                speed = parseInt(speed) - 100;
                speed = (speed / 10) * itemsize;
                duration = duration - speed;
              } else if (speed < "100") {
                speed = 100 - parseInt(speed);
                speed = (speed / 10) * (itemsize * 8);
                duration = duration + speed;
              }
              //let speed = (itemcount * duration) / 1000;
               speed = (itemcount * duration) / 1000;
              infiniteFeature.style.setProperty("animation-duration", speed + "s");
          }
        });
      }
    })
}
 */